import { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ChevronDownIcon from '@untitled-ui/icons-react/build/esm/ChevronDown';
import LogOut01Icon from '../../../icons/untitled-ui/duocolor/log-out-01';
import { Box, IconButton, Stack, SvgIcon, Typography } from '@mui/material';
import { TenantPopover } from '../tenant-popover';
import { format, getHours } from 'date-fns';
import { getAuth, createUserWithEmailAndPassword, signOut } from "firebase/auth"
const tenants = ['Devias', 'Acme Corp'];

export function TenantSwitch() {

  const auth = getAuth()

  const dataAtual = new Date()
  const horaAtual = getHours(dataAtual)

  let saudacao

  if (horaAtual >= 6 && horaAtual < 12) {
    saudacao = 'Bom dia';
  } else if (horaAtual >= 12 && horaAtual < 18) {
    saudacao = 'Boa tarde';
  } else {
    saudacao = 'Boa noite';
  }

  return (
    <>
      <Stack
        alignItems="center"
        direction="row"
        spacing={8.9}>
        <Box sx={{ flexGrow: 1 }}>
        <Typography
            color="neutral.400"
            variant="body2"
          >
            {saudacao},
          </Typography>
          <Typography
            color="inherit"
            variant="body1"
          >
            Adm Bela Cruz
          </Typography>
          
        </Box>
        <IconButton
        onClick={() => {
          const auth = getAuth()
          
          signOut(auth)
          .then(() => {
            // Logout bem-sucedido
            console.log('Logout realizado com sucesso');
          })
          .catch((error) => {
            // Trate possíveis erros
            console.log('Erro ao fazer logout:', error);
          });
        }}
        >
          <SvgIcon sx={{ fontSize: 16 }}>
            <LogOut01Icon />
          </SvgIcon>
        </IconButton>
      </Stack>
    </>
  )
}
